import { notify } from 'utils/reduxUtils';

export const types = {
  QUANTITIES_MODAL_CLOSE:
    'quotes/quoteItems/modals/Quantities/QUANTITIES_MODAL_CLOSE',
  QUANTITIES_MODAL_OPEN:
    'quotes/quoteItems/modals/Quantities/QUANTITIES_MODAL_OPEN',
  UPDATE_QUANTITIES_REQUEST:
    'quotes/quoteItems.Quantities/UPDATE_QUANTITIES_REQUEST',
  UPDATE_QUANTITIES_SUCCESS:
    'quotes/quoteItems.Quantities/UPDATE_QUANTITIES_SUCCESS',
  UPDATE_QUANTITIES_ERROR:
    'quotes/quoteItems.Quantities/UPDATE_QUANTITIES_ERROR',
};

export const quantitiesModal = {
  close: () => ({
    type: types.QUANTITIES_MODAL_CLOSE,
  }),
  open: (quoteItemId, componentId) => ({
    type: types.QUANTITIES_MODAL_OPEN,
    payload: {
      quoteItemId,
      componentId,
    },
  }),
};

export const updateQuantities = {
  request: (data) => ({
    type: types.UPDATE_QUANTITIES_REQUEST,
    payload: { data },
  }),
  success: notify(
    () => ({
      type: types.UPDATE_QUANTITIES_SUCCESS,
    }),
    'Successfully updated quantities',
  ),
  failure: notify(
    (error) => ({
      type: types.UPDATE_QUANTITIES_ERROR,
      payload: { error },
    }),
    'Failed to update quantities',
  ),
};
